module.exports = __webpack_public_path__ + "static/media/global-shoppng-43.af8c88a8.png";